import {
  Button,
  DateField,
  FlagField,
  Grid,
  MultiCheckboxField,
  Theme,
  Typography,
  makeStyles,
} from '@forgeglobal/design-framework'
import { Field, Form } from 'react-final-form'
import { TodoItemStatusType } from 'graphql/bindings/AdminBindings'
import { netWorth, targetCheckSize } from 'util/Enums'
import React from 'react'

export interface LeadFilters {
  netWorth?: string[]
  targetCheckSize?: string[]
  emailVerified?: boolean
  isAccredited?: boolean
  dateSignedUp?: Date
  leadStatus: null | TodoItemStatusType
  profileAssignee?: null | number
}
interface LeadsDashboardFiltersProps {
  filters: LeadFilters
  onFilterChange: (filters: LeadFilters) => void
  hideModal: () => void
  defaultFilters: LeadFilters
}

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}))

export const LeadsDashboardFilter: React.FC<LeadsDashboardFiltersProps> = ({
  filters,
  onFilterChange,
  hideModal,
  defaultFilters,
}) => {
  const classes = useStyles()

  const onSubmit = (ev: LeadFilters) => {
    // These checkboxes only toggle between true or undefined (show everything).
    // false (e.g. only showing people with un-verified emails) is not supported here.
    if (ev.emailVerified === false) {
      delete ev.emailVerified
    }
    if (ev.isAccredited === false) {
      delete ev.isAccredited
    }
    hideModal()
    onFilterChange(ev)
  }

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={filters}
      render={({ form, handleSubmit }) => (
        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={2} justify="center">
            <Grid item xs={3}>
              <Typography>Net Worth</Typography>
              <MultiCheckboxField name="netWorth" options={netWorth} />
            </Grid>
            <Grid item xs={4}>
              <Typography>Check Size</Typography>
              <MultiCheckboxField name="targetCheckSize" options={targetCheckSize} />
            </Grid>
            <Grid container item xs={5} direction="column">
              <Grid item>
                <Field name="emailVerified" label="Email Verified" component={FlagField} fullWidth />
              </Grid>
              <Grid item>
                <Field name="isAccredited" label="Accredited" component={FlagField} fullWidth />
              </Grid>
              <Grid item>
                <Typography>Date Signed Up</Typography>
                <DateField label="Choose a date" name="dateSignedUp" />
              </Grid>
            </Grid>
          </Grid>
          <Grid container justify="center">
            <Button onClick={() => form.reset(defaultFilters)}>Reset</Button>
            <Button color="primary" type="submit">
              Apply
            </Button>
          </Grid>
        </form>
      )}
    />
  )
}
